import React, { useState } from 'react';
import { Checkbox, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { decodeSpecLetters } from '../../../../Utility/utility';

export const ExtraCheckBoxTypes = ({
  data,
  handleChange,
  checkedList,
  panelKey,
  isDataLoaded,
  emptyListText,
}) => {
  const [filterVal, setFilterVal] = useState('');

  const filterList = ({ target }) => {
    setFilterVal(target.value);
  };

  const getList = () =>
    data.filter(({ name = '' }) =>
      name.toUpperCase().includes(filterVal.toUpperCase())
    );

  return (
    <>
      <Input
        className="search-collapse-input"
        onClick={(e) => e.stopPropagation()}
        onChange={filterList}
        suffix={<SearchOutlined />}
        onPressEnter={(e) => e.stopPropagation()}
        allowClear
        // style={{top: 101}}
      />
      <div className="entity-list-wrapper">
        <Checkbox.Group
          onChange={(e) => handleChange(e, panelKey)}
          className="sub-checkbox-list"
          value={checkedList}
        >
          {data && isDataLoaded && data.length === 0 ? (
            <span style={{ color: '#777777' }}>{emptyListText}</span>
          ) : (
            getList().map(({ id, avatar, name, photo }) => (
              <Checkbox className="check-box-style" value={id} key={id}>
                <img
                  className="list-item-img"
                  src={avatar || photo}
                  width="20"
                  height="20"
                  alt="l"
                />
                <div className="list-item-title">
                  <div style={{ width: '180px', height: '17px' }}>
                    {decodeSpecLetters(name)}
                  </div>
                </div>
              </Checkbox>
            ))
          )}
        </Checkbox.Group>
      </div>
    </>
  );
};
